<template>
  <div class="bg-F6F6F6 height-full fb fb-col">
    <div class="bg-FFFFFF">
      <md-tabbar
        v-if="showTabs"
        v-model="tabIndex"
        indicatorColor="#171A1D"
        :fixed="computedTabList.length < 4"
      >
        <md-tabbar-item
          v-for="item in computedTabList"
          :key="item.id"
          :name="item.id"
        >
          {{ item.name }}({{ list[item.countText] || 0 }})
        </md-tabbar-item>
      </md-tabbar>
      <div
        v-if="tagList && tagList.length > 1"
        class="p-0-16 lh-48 h-48 nowrap w-full scroll-x"
      >
        <span
          @click="handlerChangeTag(item)"
          v-for="(item, index) in tagList"
          :key="`tag${index}`"
          class="font-28 text-center inline-block ff-regular lh-30 h-30 p-0-12 mr-16 bd-radio-9999"
          :class="
            tagIndex === item.id
              ? 'bg-006AFE c-FFFFFF'
              : 'bg-191F25-8 c-171A1D-40'
          "
          >{{ item.name
          }}<span v-show="item.id"
            >({{ item.id ? item.num : list[tabObj[+tabIndex]] || 0 }})</span
          ></span
        >
      </div>
    </div>
    <div
      class="item-flex-1 scroll mt-12"
      @scroll="handlerLoadingDetailMore"
      v-if="detailList && detailList.length"
    >
      <div
        class="font-24 bg-FFFFFF pb-10 mb-12"
        v-for="(item, index) in detailList"
        :key="index"
      >
        <div
          class="c-171A1D-56 p-0-16 lh-20 p-8-0"
          v-show="!isPropHeadmaster"
          >{{ item.dingDeptName }}</div
        >
        <div class="user-list">
          <studentHead
            v-for="user in item.userDailyStatesList"
            :key="user.dingUserId"
            :student-info="user"
            show-padding-left
            show-all-class
            max-width="300"
            show-line
            @click="handlerClickDetail(user)"
          >
            <template slot="desc" v-if="![7, 8].includes(+tabIndex)">
              <div
                :class="+tabIndex === 6 ? 'text-right' : 'w-100 text-center'"
              >
                <p class="c-171A1D-60 font-34" v-if="+tabIndex === 6">
                  <template>
                    {{ user.leaveTypeName }}
                    {{ user.fever ? ' (发热)' : '' }}
                  </template>
                </p>
                <p class="c-171A1D-40 font-34">{{ user.time }}</p>
                <p class="c-171A1D-40 font-24" :class="{ 'pt-6': user.time }">
                  {{ user.status }}
                </p>
              </div>
            </template>
          </studentHead>
        </div>
      </div>
    </div>
    <div v-else class="w-fullVw item-flex-1 relative" style="min-height: 216px">
      <common-no-data class="no-record">
        <div class="no-item"></div>
        <p class="font-28 c-171A1D-40">当天暂无记录</p>
      </common-no-data>
    </div>
  </div>
</template>

<script>
import commonNoData from './commonNoData'
import studentHead from './studentHead'
import {} from '@/utils/constUtils'
import { timeFormat } from '@/utils/comUtils'
import mixin from '../mixin'
import API from '../api'
export default {
  mixins: [mixin],
  name: '',
  components: { commonNoData, studentHead },
  props: {
    classTime: {
      type: String,
      default: timeFormat(new Date(), 'YYYY-MM-DD')
    },
    isPropHeadmaster: {
      type: Boolean,
      default: false
    },
    dingDeptIds: {
      type: [String, Number],
      default: ''
    },
    deptType: {
      type: [String, Number],
      default: ''
    },
    list: {
      type: Object,
      default: () => {}
    },
    stateId: {
      type: [String, Number],
      default: ''
    },
    fixedScroll: {
      type: Number,
      default: 113
    }
  },
  data() {
    return {
      tabList: [],
      tabIndex: +(this.stateId || this.$store.getters.inOutType),
      tagList: [],
      tabObj: {},
      tagIndex: '',
      detailList: [],
      isLoadDetailMore: true,
      pageNum: 1,
      pageSize: 10,
      noNeedCheckStatus: '',
      isInit: true,
      showLoading: null,
      showTabs: false
    }
  },
  computed: {
    computedTabList() {
      return this.tabList.filter(
        item => +item.id !== 3 || +this.$store.getters.inOutType === 1
      )
    }
  },
  watch: {
    '$store.getters.inOutType'() {
      !this.isInit && this.initTabList()
    },
    classTime() {
      !this.isInit && this.initTabList()
    },
    dingDeptIds() {
      !this.isInit && this.initTabList()
    },
    tabIndex(val) {
      this.handlerChangeState(
        this.tabList.find(item => +item.id === +val),
        false,
        true,
        true
      )
    },
    computedTabList: {
      deept: true,
      handler() {
        this.showTabs = false
        this.$nextTick(() => {
          if (this.computedTabList.length) {
            this.showTabs = true
          }
        })
      }
    }
  },
  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {
    this.showLoading = this.$Toast({
      type: 'loading',
      duration: 9000,
      content: '加载中···'
    })
    setTimeout(() => {
      this.isInit = false
      this.initTabList()
    }, 100)
  },
  beforeUpdate() {},
  updated() {},
  activated() {},
  deactivated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    // 初始化tab
    initTabList() {
      switch (`${this.$store.getters.inOutType}`) {
        case '1':
          this.noNeedCheckStatus = 'noNeedCheckIn'
          this.tabList = [
            {
              id: 1,
              name: '正常',
              countText: 'normalCheckInCount'
            },
            {
              id: 3,
              name: '迟到',
              countText: 'lateMemberCount'
            },
            {
              id: 8,
              name: '未打卡',
              countText: 'schoolBlankMemberCount'
            },
            {
              id: 6,
              name: '请假',
              countText: 'leaveCheckInCount'
            }
          ]
          this.tabObj = {
            1: 'normalCheckInCount',
            3: 'lateMemberCount',
            8: 'schoolBlankMemberCount',
            6: 'leaveCheckInCount'
          }
          break
        case '2':
          this.noNeedCheckStatus = 'noNeedCheckOut'
          this.tabList = [
            {
              id: 2,
              name: '正常',
              countText: 'normalCheckOutCount'
            },
            {
              id: 7,
              name: '未打卡',
              countText: 'homeBlankMemberCount'
            },
            {
              id: 6,
              name: '请假',
              countText: 'leaveCheckOutCount'
            }
          ]
          this.tabObj = {
            2: 'normalCheckOutCount',
            7: 'homeBlankMemberCount',
            6: 'leaveCheckOutCount'
          }
          break
      }
      let _tabId = this.tabList.map(item => {
        return item.id
      })
      this.tabIndex =
        _tabId.indexOf(+this.tabIndex) > -1 ? this.tabIndex : _tabId[0]
      this.handlerChangeState({ id: this.tabIndex }, false, true)
    },
    // 切换状态 (状态，是否是滚动，是否是初始化, 初始化标签)
    handlerChangeState(state, isScroller, initPage, initTag) {
      initPage && (this.pageNum = 1) && (this.detailList = [])
      initTag && (this.tagIndex = '')
      this.showLoading.show()
      // 考勤组ID、时间段ID
      let { attendanceGroupId, timePeriodId } =
        this.$store.getters.attendanceQueryFilter || {}
      let _params = {
        campusId: this.campusId,
        operUserRoleTypes: this.currentRole,
        dingUserId: '',
        dimDay: this.classTime.replace(/-/gi, ''),
        checkInState:
          +state.id === 9 ? +this.$store.getters.inOutType : +state.id,
        leaveType: +state.id === 6 ? this.tagIndex : '',
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        accommodationTagId: +state.id === 6 ? '' : this.tagIndex,
        inOutType: this.$store.getters.inOutType
      }
      if (this.dingDeptIds) {
        _params.dingDeptId = this.dingDeptIds || ''
        _params.deptType = this.deptType || ''
      }
      if (timePeriodId) {
        _params.timePeriodId = timePeriodId
      }
      if (attendanceGroupId) {
        _params.attendanceGroupId = attendanceGroupId
      }
      API.getUserDayAttendanceStatInOutType(_params)
        .then(res => {
          this.tabIndex = state.id
          if (res && res.leaveTypeDtoList && res.leaveTypeDtoList.length) {
            this.tagList = [
              {
                id: '',
                name: '全部',
                num: this.list[this.tabObj[+this.tabIndex]]
              }
            ]
            res.leaveTypeDtoList.forEach(leave => {
              this.tagList.push({
                id: leave.leaveType,
                name: leave.leaveTypeName,
                num: leave.leaveMemberCount
              })
            })
          } else if (res && res.tagInfoDtoList && res.tagInfoDtoList.length) {
            this.tagList = [
              {
                id: '',
                name: '全部',
                num: this.list[this.tabObj[+this.tabIndex]]
              }
            ]
            res.tagInfoDtoList.forEach(tag => {
              this.tagList.push({
                id: tag.accommodationTagId,
                name: tag.tagName,
                num: tag.tagMemberCount
              })
            })
          } else {
            this.tagList = []
          }
          let _res = (res && res.deptDailyStatesList) || []
          if (!_res || !_res.length || _res.length < this.pageSize) {
            this.isLoadDetailMore = false
          } else {
            ++this.pageNum
            this.isLoadDetailMore = true
          }
          let _detailList =
            (_res &&
              _res.length &&
              _res.map(item => {
                let _students = item.userDailyStatesList || []
                _students &&
                  _students.map(student => {
                    student.tpId = student.dingUserId
                    student.time = ''
                    student.status = ''
                    student.gender = student.sexTypeValue
                    student.dormTag = student.tagName
                    switch (`${state.id}`) {
                      case '1':
                        student.time = +student.dayTime
                          ? timeFormat(new Date(+student.dayTime), 'hh:mm')
                          : ''
                        student.status =
                          student[this.noNeedCheckStatus] === 1
                            ? '不用打卡'
                            : ''
                        break
                      case '2':
                        student.time = +student.dayTime
                          ? timeFormat(new Date(+student.dayTime), 'hh:mm')
                          : ''
                        student.status =
                          student[this.noNeedCheckStatus] === 1
                            ? '不用打卡'
                            : ''
                        break
                      case '3':
                        student.time = +student.dayTime
                          ? timeFormat(new Date(+student.dayTime), 'hh:mm')
                          : ''
                        student.status = `迟到${student.periodMinutes || 0}分钟`
                        break
                      case '6':
                        if (+student.leaveDurationUnit === 2) {
                          student.status = `请假${(
                            (student.leaveEndTime - student.leaveStartTime) /
                            (24 * 60 * 60 * 1000)
                          ).toFixed(1)}天`
                        } else {
                          student.status = this.methodHour(
                            student.periodMinutes
                          )
                        }
                        break
                    }
                    return student
                  })
                return item
              })) ||
            []
          // 代码回退
          // console.log(11111, JSON.stringify(_detailList))
          // // 筛选班级之后点击环状图，显示所有班级数据问题修复
          // if (this.$store.getters.attendanceSelectDetailNodes) {
          //   console.log(2222, this.$store.getters.attendanceSelectDetailNodes)
          //   _detailList = _detailList.filter(
          //     item =>
          //       this.$store.getters.attendanceSelectDetailNodes.findIndex(
          //         node => {
          //           console.log(
          //             3333,
          //             node.deptDingId,
          //             item.dingDeptId,
          //             node.deptDingId === item.dingDeptId
          //           )
          //           return node.deptDingId === item.dingDeptId
          //         }
          //       ) >= 0
          //   )
          // }
          // console.log(4444, JSON.stringify(_detailList))
          this.detailList = isScroller
            ? this.detailList.concat(_detailList)
            : _detailList
        })
        .catch(err => {
          console.log('unhandledrejection', err)
        })
        .finally(_ => this.showLoading && this.showLoading.hide())
    },
    // 加载更多
    handlerLoadingDetailMore(e) {
      if (this.isPropHeadmaster) {
        return
      }

      let _el = e.currentTarget
      // clientHeight
      if (
        _el.scrollTop + _el.clientHeight >= _el.scrollHeight - 20 &&
        this.isLoadDetailMore
      ) {
        this.isLoadDetailMore = false
        this.handlerChangeState({ id: this.tabIndex }, true, false)
      }
    },
    // 时间计算
    methodHour(time) {
      let _time = ''
      if (time > 60) {
        const _HOURS = (time / 60).toFixed(1)
        _time = `请假${_HOURS}小时`
      } else {
        _time = `请假${time}分钟`
      }
      return _time
    },
    // 切换标签
    handlerChangeTag(item) {
      this.tagIndex = item.id
      this.initTabList()
    },
    // 跳转详情
    handlerClickDetail(studentInfo) {
      let _date = this.classTime.replace(/-/gi, '')
      let _month = _date.substring(0, 6)
      this.$store.commit('calendarTime', _date)
      this.$store.commit('studentInfo', null)
      this.$store.commit('isCalendarForm', false)
      if (studentInfo.tpId) {
        let _postData = {
          studentId: studentInfo.tpId
        }
        API.dingGetStudentBaseInfo(_postData)
          .then(res => {
            let student = {
              time: _date,
              dingUserId: res.studentId,
              dingDeptId: res.classId,
              userName: res.name,
              sexTypeValue: studentInfo.sexTypeValue,
              tagName: studentInfo.tagName,
              dormName: studentInfo.dormName
            }
            API.fishnetGetDeptInfo({ deptTpId: res.classId })
              .then(response => {
                student.dingDeptName = response.deptName
                this.$store.commit('studentInfo', student)
                this.$router.push({
                  path: '/attendance/pageAttendanceMonthCalendar',
                  query: {
                    studentInfo: JSON.stringify(student),
                    date: _month
                  }
                })
              })
              .catch(err => {
                console.log('unhandledrejection', err)
              })
          })
          .catch(err => {
            console.log('unhandledrejection', err)
          })
        return ''
      }
      this.$store.commit('studentInfo', studentInfo)
      this.$router.push({
        path: '/attendance/pageAttendanceMonthCalendar',
        query: {
          studentInfo: JSON.stringify(studentInfo),
          date: _month
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.head-img {
  height: 36px;
  width: 36px;
  margin-right: 12px;
  img {
    height: 36px;
    width: 36px;
    border-radius: 50%;
  }
}
.head-img-name {
  margin-right: 12px;
  height: 36px;
  width: 36px;
  color: #ffffff;
  background: #006afe;
  border-radius: 50%;
}
.tab-bottom {
  position: absolute;
  bottom: 0;
  left: 50%;
  margin-left: -12px;
  width: 24px;
  height: 3px;
  background: #006afe;
  border-radius: 1.5px;
}
.fixed-class {
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999999;
}
.scroll-x {
  overflow-x: scroll;
}
.pt-110 {
  padding-top: 110px;
}
.no-record {
  .no-item {
    width: 180px;
    height: 180px;
    background: url(~@/assets/images/no-data.png) no-repeat center center;
    background-size: 100% 100%;
  }
}
</style>
